import { render } from "./SuicaTop.vue?vue&type=template&id=1aa3df89&scoped=true"
import script from "./SuicaTop.vue?vue&type=script&lang=js"
export * from "./SuicaTop.vue?vue&type=script&lang=js"

import "./SuicaTop.vue?vue&type=style&index=0&id=1aa3df89&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa3df89"]])

export default __exports__